import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { PurchaseHistoryItemDto } from '../dtos';

export enum PurchaseHistoryActionTypes {
  GetPurchaseHistory = '[PurchaseHistory] GetPurchaseHistory',
  GetPurchaseHistorySuccess = '[PurchaseHistory] GetPurchaseHistorySuccess',
  GetPurchaseHistoryError = '[PurchaseHistory] GetPurchaseHistoryError',
}

export const getPurchaseHistoryAction = createAction(PurchaseHistoryActionTypes.GetPurchaseHistory);
export const getPurchaseHistorySuccessAction = createAction(
  PurchaseHistoryActionTypes.GetPurchaseHistorySuccess,
  props<{ purchaseHistoryItems: Array<PurchaseHistoryItemDto> }>()
);
export const getPurchaseHistoryErrorAction = createAction(
  PurchaseHistoryActionTypes.GetPurchaseHistoryError,
  props<{ failures: AppStateFailure }>()
);
